import { IoCContainer } from '@writefull/core'

import { ModalsStore, modalsStore } from './modals/modals-store'
import { NotificationsStore, notificationsStore } from './notifications/notifications-store'
import { SessionStore, sessionStore } from './session/session-store'
import { SettingsStore, settingsStore } from './settings/settings-store'

export const registerStores = (container: IoCContainer) => {
  container.bindStore(SessionStore, sessionStore)
  container.bindStore(NotificationsStore, notificationsStore)
  container.bindStore(ModalsStore, modalsStore)
  container.bindStore(SettingsStore, settingsStore)
}
